import TableWidget from "csi/table/Widget";
import { pathCreate } from "csi/utility/pathUtility";
import Search from "csi/xml/Search";
import declare from "dojo/_base/declare";
import { getMatrixPresence, sortSpecItemNodes } from "src/SpecificationDataSheet/sharedSectionMatrixService";

export = declare(TableWidget, {
	/** shared sections of all components */
	sharedSections: null,

	/** the spec items across component  */
	specItemsAcrossComponent: null,

	/**
	 * Grab all the spec items as the column nodes for the matrix
	 * @override
	 */
	onViewStart(dfds: PromiseLike<any>[]): void {
		// SharedSpecItemDefinitionMap won't be populated until user creates spec data sheet, also, these SpecificationDataSheetItem nodes would be rendered in the matrix, won't be too big, hopefully, won't cause performance issue
		// if we do have the performance issue, we could introduce a Java operation to only grab the SpecificationDataSheetItem nodes on the Components
		const matrixAvailability = getMatrixPresence(this.attributeSpecs);

		// if none is present, query is not necessary anymore
		if (matrixAvailability.specItemIsAvailable || matrixAvailability.specSectionIsAvailable) {
			const search = new Search().byType("Component");
			search.addDependencyPaths([pathCreate("SharedSpecSections", "SectionItems", "Definition", "ValueAttributeDefinition")]);

			dfds.push(search.execute().then((response) => {
				this.cacheView.cacheResponse(response);
				const specItems = response.getNodesOfType("SpecificationItemDefinition") || [];

				this.specItemsAcrossComponent = sortSpecItemNodes(specItems, "UDCMatrixSortCode", this.cacheView);
				this.sharedSections = response.getNodesOfType("SpecificationSection") || [];
			}));
		}
	},
});
